<template>
    <a-modal title="对接需求资料" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" width="65%">
        <a-form layout="horizontal" ref="ruleForm" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item label="id" name="id">
                    <a-input v-model:value="form.id"/>
                </a-form-item>
                <a-form-item label="urlType" name="urlType">
                    <a-input v-model:value="form.urlType"/>
                </a-form-item>
            </div>
            <a-row :gutter="[24,8]">
                <a-form-item label="对接资料文件" name="abutmentFile">
                    <file-upload v-model:value="form.abutmentFile"/>
                </a-form-item>

                <!--可编辑区域 end-->
            </a-row>
        </a-form>

    </a-modal>
</template>
<script>
    // import dataCheck from "@/utils/dataCheck";
    import {formMixin} from "@/mixins";
    import {demandApi} from "@/api/innovationService";
    import {innovation} from "@/config/variableConfig";

    export default {
        name: "AddOrEditModal",
        components: {},

        mixins: [formMixin],
        data() {
            return {
                innovation,
                form: {
                    id: null,
                    urlType: null,
                    abutmentFile: null,

                },
                rules: {
                    id: [],
                    urlType: [],
                    abutmentFile: [],
                },

            }
        },
        computed: {
            submitUrl() {
                return this.form.urlType =='1' ? demandApi.verify : demandApi.accomplish
            }

        },
        mounted() {
        },
        methods: {
        },
    }
</script>
<style scoped lang="less">
</style>
